// extracted by mini-css-extract-plugin
module.exports = {"increase":"_62-fH","goToLogin":"_8IQbH","buttonsBlock":"gDTEj","additionalInfo":"jDi1c","reverseDirection":"MA8Be"};